import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'app-custom-button',
    templateUrl: './custom-button.component.html',
    styleUrls: ['./custom-button.component.scss'],
    standalone: false
})
export class CustomButtonComponent {
  @Input() title: string
  @Input() showSpinner: boolean
  @Input() styleClass: any
  @Input() disableBtn: boolean
  @Input() icon?: string

  @Output() clicked: EventEmitter<void> = new EventEmitter()

  constructor() {}
}
